// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "main[data-v-29f23a5e]{background-color:#f5f5ff}.skip-link[data-v-29f23a5e]{left:12px;top:12px;z-index:1000;position:absolute;transform:translateY(-200%);transition:transform .2s ease;background:#fff;border:2px solid #005fcc;color:#003e8c;padding:8px 12px;border-radius:6px;font-weight:600}.skip-link[data-v-29f23a5e]:focus{transform:translateY(0)}", ""]);
// Exports
module.exports = exports;
